<template>
  <div>
    <a @click="scrollTop" v-show="visible" class="bottom-right">
      <a class="main-scroll-icon">
        <i-icon icon="fa6-solid:angle-up" />
      </a>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 20);
    },
    scrollListener: function () {
      this.visible = window.scrollY > 150;
    },
  },
  mounted: function () {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeUnmount: function () {
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style scoped>
.bottom-right {
  position: fixed;
  bottom: 10%;
  right: 10px;
  cursor: pointer;
  z-index: 100;
}

.main-scroll-icon {
  border: 1px solid var(--secondary-color);
  color: #000;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background-color: #fff;
  border-radius: 50%;
}

@media only screen and (max-width: 600px) {
  .bottom-right {
    bottom: 10px;
  }
}
</style>
